export enum ContentType {
  company = "company",
  navItem = "navItem",
  document = "document"
}

export enum NavigationType {
  base = "base",
  primary = "primary",
  secondary = "secondary",
  tertiary = "tertiary",
  tertiaryExt = "tertiaryExt"
}

export enum PageTitle {
  ourTours = "Our Tours",
  waysToTravel = "Ways To Travel",
  whyCollette = "Why Collette",
  deals = "Deals",
  brochures = "Brochures",
  travelPlanning = "Travel Planning"
}